export default "__VITE_ASSET__B5ifAE90__"